import { render, staticRenderFns } from "./SalesInsight.vue?vue&type=template&id=3ea8dc04"
import script from "./SalesInsight.vue?vue&type=script&lang=js"
export * from "./SalesInsight.vue?vue&type=script&lang=js"
import style0 from "./SalesInsight.vue?vue&type=style&index=0&id=3ea8dc04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports